// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"afc3b296","75":"d32983a7","85":"697035f5","115":"655750c4","328":"2016cfc2","371":"35c89caf","379":"f9cbc74f","570":"3696f324","613":"b11a09c5","741":"9d101d21","746":"74186645"}[chunkId] + ".chunk.js";
};